import {ValueObject} from '@s-ui/domain'

export class ModelVersionsValueObject extends ValueObject {
  /**
   * @param {String} make
   * @param {String} model
   * @param {String} mainImage
   * @param {RelatedVehiclesListValueObject} competitors
   * @param {OfferPriceValueObject} lowerFinancedOfferPrice
   * @param {OfferPriceValueObject} lowerSpotOfferPrice
   * @param {Number} lowerVersionPrice
   * @param {Array<VehicleOfferValueObject>} items
   * @param {VehicleInsightsValueObject} vehicleInsights
   * */
}
